import { gql } from '@apollo/client';
import { textPairFragment, fieldOptionListValueFragment } from '../../../query/fragments';

export const EMAIL_US_MODULE_QUERY = gql`
  query EmailUsModuleQuery {
    textFor {
      emailUsLabelText: pair(pairKey: "emailUsLabel") { ...textPair }
    }
  }
  ${textPairFragment}
`;

export const EMAIL_US_MODAL_TEXT_QUERY = gql`
  query EmailUsModalText {
    textFor {
      modalHeading: pair(pairKey: "emailUsModalHeading") { ...textPair }
    }
    enableGladlyCustomerCareWebform: featureFlag(
      key: "enable-gladly-customer-care-webform",
      defaultValue: false
    )
  }

  ${textPairFragment}
`;

export const EMAIL_US_FORM_TEXT_QUERY = gql`
  query EmailUsFormText {
    textFor {
      formFieldName: textField(fieldKey: "emailUsFormName") {
        label { ...textPair }
        error { ...textPair }
      }
      formFieldFirstName: textField(fieldKey: "emailUsFormFirstName") {
        label { ...textPair }
        error { ...textPair }
      }
      formFieldLastName: textField(fieldKey: "emailUsFormLastName") {
        label { ...textPair }
        error { ...textPair }
      }
      formFieldEmailAddress: textField(fieldKey: "emailUsFormEmailAddress") {
        label { ...textPair }
        error { ...textPair }
      }
      formFieldOrderNumber: textField(fieldKey: "emailUsFormOrderNumber") {
        label { ...textPair }
        error { ...textPair }
      }
      formFieldDetails: textField(fieldKey: "emailUsFormDetails") {
        label { ...textPair }
        error { ...textPair }
      }
      formFieldEmail: textField(fieldKey: "emailUsFormEmail") {
        label { ...textPair }
        error { ...textPair }
      }
      formFieldOrderNum: pair(pairKey: "emailUsFormOrderNum") { ...textPair }
      formFieldDropDown: listField(fieldKey: "emailUsFormDropDown") {
        ...fieldOptionListValues
      }
      formFieldComments: textField(fieldKey: "emailUsFormComments") {
        label { ...textPair }
        error { ...textPair }
      }
      modalHeading: pair(pairKey: "emailUsModalHeading") { ...textPair }
      formReasons: pair(pairKey: "emailUsFormReasons") { ...textPair }
      formResponseNote: pair(pairKey: "emailUsFormResponseNote") { ...textPair }
      formLegal: pair(pairKey: "emailUsFormLegal") { ...textPair }
      formError: pair(pairKey: "formError") { ...textPair }
      formDisputeLabel: pair(pairKey: "emailUsFormDisputeLabel") { ...textPair }
      buttonProcessing: pair(pairKey: "processing") { ...textPair }
      buttonSubmit: pair(pairKey: "emailUsButtonSubmit") { ...textPair }
      buttonSuccess: pair(pairKey: "emailUsButtonSuccess") { ...textPair }
      formOrderNumberTooltipContent: pair(pairKey: "emailUsTooltipContent") { ...textPair }
      formOrderNumberToolTipLabel: pair(pairKey: "emailUsToolTipLabel") { ...textPair }
      formOrderShipArriveDirections: pair(pairKey: "emailUsShipArriveDirections") { ...textPair }
      formCancelOrderDirections: pair(pairKey: "emailUsCancelOrderDirections") { ...textPair }
      formReturnExchangeDirections: pair(pairKey: "emailUsReturnExchangeDirections") { ...textPair }
      formWhatDoYouNeedHelpWith: pair(pairKey: "emailUsWhatDoYouNeedHelpWith") { ...textPair }
      formYouAreTakenToEmail: pair(pairKey: "emailUsYouAreTakenToEmail") { ...textPair }
      formServiceRequestNote: pair(pairKey: "emailUsServiceRequestNote") { ...textPair }
      formGoToEmail: pair(pairKey: "emailUsGoToEmail") { ...textPair }
      formRequiredField: pair(pairKey: "emailUsRequiredField") { ...textPair }
      formEmailUsHeading: pair(pairKey: "emailUsHeading") { ...textPair }
      formContinueButton: pair(pairKey: "continue") { ...textPair }
      formGotItButton: pair(pairKey: "successModalButtonText") {...textPair}
    }
    featureConfig {
      gladlyCustomerServiceEmail: string(key: "gladly-customer-service-email")
    }
  }

  ${fieldOptionListValueFragment}
  ${textPairFragment}
`;

export const SEND_EMAIL_MUTATION = gql`
  mutation SendEmail($emailForm: EmailForm!) {
    sendEmail(emailForm: $emailForm) { id }
  }
`;
